import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { getAvailableBalance } from '../../../modules/account/selectors';
import { saveAmount } from '../actions';
import LearnMoreNote from '../LearnMoreNote';
import { getWithdrawPage } from '../../../modules/content/selectors';
import backupContent from '../../../../resources/withdrawBackup.json';

export class Request extends Component {
  static isDisabled(maxAmount) {
    return isNaN(maxAmount) || maxAmount <= 0;
  }

  static maxAmountError(amount, maxAmount) {
    return isNaN(amount) || !amount || amount < 0 || amount > maxAmount;
  }

  static poundsError(amount) {
    const intValue = parseInt(amount, 10);
    return isNaN(intValue) || !intValue || intValue < 0 || !/^\d+$/.test(amount);
  }

  constructor(props) {
    super(props);
    this.updateRequestAmount = this.updateRequestAmount.bind(this);
    this.submitRequest = this.submitRequest.bind(this);
    this.amountInput = null;
    const { maxAmount } = props;
    const disabled = Request.isDisabled(maxAmount);
    this.state = {
      inputValue: '',
      amount: 0,
      inputDisabled: disabled,
      submitDisabled: true
    };
  }

  componentWillReceiveProps(newProps) {
    const { maxAmount } = newProps;
    const inputValue = this.amountInput.value;
    const amount = parseInt(inputValue, 10);
    const disabled = Request.isDisabled(maxAmount);
    const maxAmountError = inputValue !== '' && Request.maxAmountError(amount, maxAmount);
    const poundsError = inputValue !== '' && Request.poundsError(inputValue);
    this.setState({
      inputDisabled: disabled,
      submitDisabled: disabled || maxAmountError || poundsError || inputValue === '',
      maxAmountError,
      poundsError
    });
  }

  updateRequestAmount() {
    const { maxAmount } = this.props;
    const inputValue = this.amountInput.value;
    const amount = parseInt(inputValue, 10);
    const disabled = Request.isDisabled(maxAmount);
    const maxAmountError = Request.maxAmountError(amount, maxAmount);
    const poundsError = Request.poundsError(inputValue);
    this.setState({
      amount,
      inputValue,
      inputDisabled: disabled,
      submitDisabled: disabled || maxAmountError || poundsError,
      maxAmountError,
      poundsError
    });
  }

  submitRequest(event) {
    const { onSubmit } = this.props;
    const { amount, submitDisabled } = this.state;

    if (!submitDisabled) {
      onSubmit(amount);
    }
    event.preventDefault();
    return false;
  }

  render() {
    const { maxAmount, contentStackContent } = this.props;
    const maxVisible = (maxAmount !== null) ? maxAmount : 'N/A';
    const { inputValue, inputDisabled, submitDisabled, maxAmountError, poundsError } = this.state;
    const inputClassName = classnames('withdraw-request__input-container',
      {
        'withdraw-request__input-container--disabled': inputDisabled,
        'withdraw-request__input-container--error': !inputDisabled && (maxAmountError || poundsError)
      });
    const buttonClassName = classnames('withdraw-request__button',
      { 'withdraw-request__button--disabled': submitDisabled });
    const maxAmountClassName = classnames('withdraw-request__max-amount',
      { 'withdraw-request__max-amount--error': !inputDisabled && maxAmountError });
    let content;
    if (contentStackContent) {
      content = contentStackContent;
    } else {
      content = backupContent;
    }

    return (
      <div>
        <form className="withdraw-request" onSubmit={this.submitRequest}>
          <div className="withdraw-request__row">
            <div className="withdraw-request__label">
              <span className="withdraw-request__title" dangerouslySetInnerHTML={{ __html: content.request.title }} />
              <br />
              <span className={maxAmountClassName}>
                <span dangerouslySetInnerHTML={{ __html: `${content.request.text}${maxVisible} *` }} />
              </span>
            </div>
            <div className={inputClassName}>
              <input
                className="withdraw-request__input"
                id="withdraw-request__input"
                type="tel"
                value={inputValue}
                onChange={this.updateRequestAmount}
                autoComplete="off"
                disabled={inputDisabled}
                ref={(ref) => {
                  this.amountInput = ref;
                }}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="withdraw-request__input-label" htmlFor="withdraw-request__input">
                £
              </label>
            </div>
          </div>
          {poundsError && (
            <div className="withdraw-request__row">
              <div className="withdraw-request__pounds-info" dangerouslySetInnerHTML={{ __html: content.request.poundsOnlyText }} />
            </div>
          )}
          <Button
            disabled={submitDisabled}
            className={buttonClassName}
            onClick={this.submitRequest}
          >
            <span dangerouslySetInnerHTML={{ __html: content.request.buttonText }} />
          </Button>
        </form>
        <LearnMoreNote />
      </div>
    );
  }
}

Request.propTypes = {
  maxAmount: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  contentStackContent: PropTypes.object
};

const mapStateToProps = (state) => ({
  maxAmount: getAvailableBalance(state),
  contentStackContent: getWithdrawPage(state)
});

const mapDispatchToProps = {
  onSubmit: saveAmount
};

export default connect(mapStateToProps, mapDispatchToProps)(Request);
